import { criancaFunc, visitasFunc, referenciaFunc, vrCriancaFunc } from "../../helpers/Funcionalidades";

export const handleVerifyRedirectPermission = (options, roleKeycloack, user, idPJ) => {
  const hasOrgao = (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
    roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
    user?.orgaoExterno?.includes(idPJ);

  const permissions = [
    {
      check: () => !roleKeycloack.includes(criancaFunc.editar) && !hasOrgao,
      idsToRemove: [1, 10, 36],
    },
    {
      check: () => !roleKeycloack.includes(vrCriancaFunc.documentacaoEditar) && !hasOrgao,
      idsToRemove: [2, 3, 4, 5],
    },
    {
      check: () => !roleKeycloack.includes(criancaFunc.editarPP),
      idsToRemove: [13, 14, 15, 16, 17],
    },
    {
      check: () => !roleKeycloack.includes(criancaFunc.editarSaude) && !hasOrgao,
      idsToRemove: [11, 41],
    },
    {
      check: () => !roleKeycloack.includes(criancaFunc.editarProfissionalizacao) && !hasOrgao,
      idsToRemove: [12, 20, 27],
    },
    {
      check: () => !roleKeycloack.includes(visitasFunc.visitaEditar) && !hasOrgao,
      idsToRemove: [8, 9],
    },
    {
      check: () => !roleKeycloack.includes(referenciaFunc.referenciaAlterar) && !hasOrgao,
      idsToRemove: [23],
    },
    {
      check: () => !roleKeycloack.includes(vrCriancaFunc.movimentoCadastrar) && !hasOrgao,
      idsToRemove: [6, 7, 38, 39, 40],
    },
    {
      check: () => !roleKeycloack.includes(criancaFunc.alterarEducacao) && !hasOrgao,
      idsToRemove: [22],
    },
    {
      check: () => !roleKeycloack.includes(criancaFunc.desligar),
      idsToRemove: [38, 39],
    }
  ];

  return options.filter(item => {
    return !permissions.some(permission => permission.check() && permission.idsToRemove.includes(item.id));
  });
};